import { Stage } from "./Stage";
import { Speech } from "./TalkPanel";

export class Stage2 extends Stage {
    constructor() {
        super();
        this.pushCheckPoint(50, 50);
        this.pushPlayer(50, 50);
        this.asCameraCenter();
        //外壁
        this.pushWall(-2200, -1600, 4600, 400);
        this.pushWall(-2200, -1200, 400, 3200);
        this.pushWall(-2200, 2000, 4600, 400);
        this.pushWall(2000, -1200, 400, 3200);

        //1段目
        this.pushWall(-1600, -1000, 400, 400);
        this.pushWall(-1000, -1000, 400, 400);
        this.pushWall(-400, -1000, 400, 400);
        this.pushWall(200, -1000, 400, 400);
        this.pushWall(800, -1000, 400, 400);
        this.pushSquare(1400, -1000, 400, 400);

        this.pushWall(-1800, -1200, 200, 200);
        this.pushFakePanel(-1200, -1200, 200, 200);
        this.pushSquare(-600, -1200, 200, 200);
        this.pushSquare(0, -1200, 200, 200);
        this.pushWall(600, -1200, 200, 200);
        // this.pushWall(1200, -1200, 200, 200);
        this.pushWall(1400, -1200, 200, 200);
        this.pushWall(1800, -1200, 200, 200);

        //2段目
        this.pushWall(-1600, -400, 400, 400);
        this.pushWall(-1000, -400, 400, 400);
        this.pushWall(-400, -400, 400, 400);
        this.pushWall(200, -400, 400, 400);
        this.pushWall(800, -400, 400, 400);
        this.pushWall(1400, -400, 400, 400);

        this.pushFakePanel(-1800, -600, 200, 200);
        this.pushFakePanel(-1200, -600, 200, 200);
        this.pushWall(-600, -600, 200, 200);
        // this.pushWall(0, -600, 200, 200);
        this.pushWall(600, -600, 200, 200);
        this.pushWall(1200, -600, 200, 200);
        this.pushFakePanel(1800, -600, 200, 200);

        //3段目
        this.pushWall(-1600, 200, 400, 400);
        this.pushWall(-1000, 200, 400, 400);
        this.pushWall(-400, 200, 400, 400);
        this.pushWall(200, 200, 400, 400);
        this.pushWall(800, 200, 400, 400);
        this.pushWall(1400, 200, 400, 400);

        this.pushWall(-1800, 0, 200, 200);
        this.pushFakePanel(-1200, 0, 200, 200);
        this.pushWall(-600, 0, 200, 200);
        // this.pushWall(0, 0, 200, 200);
        this.pushFakePanel(600, 0, 200, 200);
        this.pushWall(1200, 0, 200, 200);
        this.pushFakePanel(1800, 0, 200, 200);

        //4段目
        this.pushSquare(-1600, 800, 400, 400);
        this.pushWall(-1000, 800, 400, 400);
        this.pushWall(-400, 800, 400, 400);
        this.pushWall(200, 800, 400, 400);
        this.pushWall(800, 800, 400, 400);
        this.pushWall(1400, 800, 400, 400);

        this.pushWall(-1800, 600, 200, 200);
        this.pushFakePanel(-1200, 600, 200, 200);
        this.pushWall(-1200, 800, 200, 50);
        this.pushFakePanel(-600, 600, 200, 200);
        this.pushWall(0, 600, 200, 200);
        this.pushFakePanel(600, 600, 200, 200);
        this.pushFakePanel(1200, 600, 200, 200);
        this.pushFakePanel(1800, 600, 200, 200);

        //5段目
        this.pushWall(-1600, 1400, 400, 400);
        this.pushSquare(-1000, 1400, 200, 400);
        this.pushWall(-800, 1400, 200, 400);
        this.pushWall(-400, 1400, 400, 400);
        this.pushWall(200, 1400, 400, 400);
        this.pushWall(800, 1400, 400, 400);
        this.pushWall(1400, 1400, 400, 400);

        this.pushWall(-1800, 1200, 200, 200);
        this.pushWall(-1200, 1200, 200, 200);
        this.pushFakePanel(-600, 1200, 200, 200);
        this.pushFakePanel(0, 1200, 200, 200);
        this.pushFakePanel(600, 1200, 200, 200);
        this.pushWall(1200, 1200, 200, 200);
        this.pushWall(1800, 1200, 200, 200);

        //最下段
        // this.pushWall(-1800, 1800, 200, 200);
        // this.pushWall(-1200, 1800, 200, 200);
        this.pushWall(-600, 1800, 200, 200);
        this.pushWall(0, 1800, 200, 200);
        this.pushFakePanel(600, 1800, 200, 200);
        this.pushFakePanel(1200, 1800, 200, 200);
        // this.pushWall(1800, 1800, 200, 200);

        this.pushWall(-1000, 1900, 200, 100);

        this.pushSignboard(50, -550, [
            new Speech({
                content: "ここには見た目通りではない壁が多いようです。",
                speakerName: "看板",
            }),
            new Speech({
                content: "見た目に惑わされずにどんどん突き進みましょう。",
                speakerName: "看板",
            }),
            new Speech({
                content: "一体どこが通れるのかしらね。",
                speakerName: "謎の声",
            }),
        ]);
        this.pushSignboard(1850, 1850, [
            new Speech({
                content: "ここは似たような景色がずっと続くから迷いそうだ。",
            }),
            new Speech({
                content: "似たような景色が続くため迷わないようにしましょう。",
                speakerName: "看板",
            }),
            new Speech({
                content: "(被った……)",
            }),
            new Speech({
                content: "隅の方へ行けばとりあえずなにかあるかもしれませんね。",
                speakerName: "看板",
            }),
        ]);
        this.pushSignboard(1650, -1150, [
            new Speech({
                content: '<font style="color:#dd0000">自分の趣味はアウトドア関係だ。</font>',
                speakerName: "記憶の欠片",
            }),
        ]);
        this.pushSignboard(-1750, 1050, [
            new Speech({
                content: '<font style="color:#dd0000">自分の趣味は"た行"と"ら行"のみからなる。</font>',
                speakerName: "記憶の欠片",
            }),
        ]);
        this.pushSignboard(-550, -750, [
            new Speech({
                content: '<font style="color:#dd0000">自分の趣味は水場でするものだ。</font>',
                speakerName: "記憶の欠片",
            }),
        ]);
        this.pushSignboard(-1750, -950, [
            new Speech({
                content: '<font style="color:#00dd00">記憶の穴</font>は左下の隅にありますよ。',
                speakerName: "看板",
            }),
            new Speech({
                content: "左下か。位置が分かっても道筋はどうだろうか。",
            }),
            new Speech({
                content: "やっぱりどこか変なところが通れるのかしら。",
                speakerName: "謎の声",
            }),
        ]);

        this.pushDescription(1800, -1000, 200, 200, "←");
        this.s$fontSize = 12;
        this.pushDescription(-1600, 600, 200, 200, "↓");
        this.s$fontSize = 12;

        this.pushGoal(-1750, 1850, 100, 100);

        // this.pushCheckPoint(700, -200);
        // this.respawnCheckPoint(1);

        this.create();
    }

    protected loop(): void {}
}
